import React from 'react';
import { selectedBtnStyle } from '../../../../../components/Molecules/Card/cardStyle';
import { INoDressing, INoDressingModifier } from '../../../../../models/try2Combo';
import styleClasses from '../../../try2.module.scss';
import NoSelectIcon from "../../../../../images/No-select-icon.svg";

const NoDressing: React.FC<INoDressing> = ({ 
 label = "",
 groupId = 0, 
 itemNo, 
 noDressingHandler, 
 isNoDressing , 
 noDressingCardBorderRadius,
 showRedBorderAnimation}) => {
  const noDressingClickHandler = () => {
    const payload: INoDressingModifier = {
      "modifier_id": 0,
      "modifier_name": `No ${label}`,
      "display_price": 0,
      "modifier_calories": "0",
      "type": "selected",
      "modifier_group_id": groupId,
      "modifier_group_max": 0,
      "code":"NO",
      "modifier_type": "TRY_2_COMBO_REQUIRED_MODIFIERS",
      "in_slide": true,
      "quantity": isNoDressing ? 0 : 1,
      "additionalPrice": 0,
      "groupId": groupId
  };
  noDressingHandler(payload, itemNo)
  }
  return (
    <div
      className={`${styleClasses.add_on_item_wrap} ${styleClasses.no_dressing_card} ${noDressingCardBorderRadius} cursor-pointer shadow-box d-flex flex-column ${isNoDressing && styleClasses.selected} ${showRedBorderAnimation ? 'border-size-select' : ''}`}
      onClick={noDressingClickHandler}
    >
      <div
        className={`${styleClasses.items_image} mb-2 flex-fill d-flex align-items-center justify-content-center`}
      >
        <img
          src={NoSelectIcon}
          className="img-fluid no-dressing-img"
          alt="ingredient"
        />
      </div>
      <h3 className={`${styleClasses.item_title} font-rale mb-3`}>
        {`No ${label}`}
      </h3>
      <button
        type="button"
        className={`btn item-select-btn mx-auto mw-auto ${isNoDressing ? 'noDressing-card-btn-selected' : ''}`}
        style={{
          ...(isNoDressing && {
              ...selectedBtnStyle,
            })
        }}
        onClick={noDressingClickHandler}
      >
      {isNoDressing ? 'Selected' :  'Select'}
      </button>
    </div>
  );
};

export default NoDressing;
